<div id="sidebar" class="sidebar">
  <div id="sidebar-content">
    <!-- ACCOUNT ADMIN -->
    <div *ngIf="!currentUser.sd">
      <ul id="nav">
        <!-- Bookings -->
        <li
          [appAbility]="['index_booking_accountadmin', 'create_booking_accountadmin']"
          id="booking"
        >
          <a href="javascript:void(0);" (click)="openSubMenu($event)">
            <i class="fa fa-calendar fa-nav" title="{{ 'BOOKINGS' | translate }}"></i>
            <span>
              {{ 'BOOKINGS' | translate }}
            </span>
            <i class="fa arrow"></i>
          </a>
          <ul class="sub-menu">
            <li class="sub-menu-title">{{ 'BOOKINGS' | translate }}</li>
            <li [appAbility]="['index_booking_accountadmin']">
              <a href="#/bookings" (click)="openSubMenuLink()">
                <i class="fa fa-calendar"></i> {{ 'BOOKINGS' | translate }}
              </a>
              <span
                class="label label-primary pull-right cursor"
                (click)="addBooking()"
                title="{{ 'NEW_BOOKING' | translate }}"
                style="margin-top: -32px; right: 0"
                [appAbility]="'create_booking_accountadmin'"
              >
                <i class="fa fa-plus"></i>
              </span>
            </li>
            <li [appAbility]="['index_booking_accountadmin']">
              <a href="#/prepayment_report" (click)="openSubMenuLink()">
                <i class="fa fa-file-text"></i>
                {{ 'PREPAYMENTS' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_receivedpayment_accountadmin'">
              <a href="#/received_payments" (click)="openSubMenuLink()">
                <i class="fa fa-money"></i> {{ 'PAYMENTS_FROM_CLIENTS' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_paymentprovider_accountadmin'">
              <a href="#/payment_providers" (click)="openSubMenuLink()">
                <i class="fa fa-money"></i> {{ 'PAYMENTS_TO_PROVIDERS' | translate }}
              </a>
            </li>
            <li [appAbility]="['index_bookingreport_accountadmin']">
              <a routerLink="/ng/bookings_report" (click)="openSubMenuLink()">
                <i class="fa fa-file-text"></i> {{ 'REPORTS' | translate }}
              </a>
            </li>
          </ul>
        </li>
        <!-- Inventory -->
        <li
          [appAbility]="[
            'index_tourinventory_accountadmin',
            'index_transportationinventory_accountadmin',
            'index_hotelinventory_accountadmin'
          ]"
          id="inventory"
        >
          <a href="javascript:void(0);" (click)="openSubMenu($event)">
            <i class="fa fa-list fa-nav" title="{{ 'INVENTORY' | translate }}"></i>
            <span>
              {{ 'INVENTORY' | translate }}
            </span>
            <i class="fa arrow"></i>
          </a>
          <ul class="sub-menu">
            <li class="sub-menu-title">{{ 'INVENTORY' | translate }}</li>
            <li
              [appAbility]="[
                'index_tourinventory_accountadmin',
                'index_transportationinventory_accountadmin',
                'index_hotelinventory_accountadmin'
              ]"
            >
              <a href="#/inventory" (click)="openSubMenuLink()">
                <i class="fa fa-list"></i>
                {{ 'INVENTORY_MANAGEMENT' | translate }}
              </a>
            </li>
            <li
              [appAbility]="[
                'index_tourprice_accountadmin',
                'index_transportationprice_accountadmin',
                'index_hotelprice_accountadmin',
                'index_packageprice_accountadmin'
              ]"
            >
              <a href="#/costs_and_prices" (click)="openSubMenuLink()">
                <i class="fa fa-money"></i>
                {{ 'COSTS_AND_PRICES' | translate }}
              </a>
            </li>
          </ul>
        </li>

        <!-- Products -->
        <li
          [appAbility]="[
            'index_tour_accountadmin',
            'index_transportation_accountadmin',
            'index_hotel_accountadmin',
            'index_package_accountadmin'
          ]"
          id="products"
        >
          <a href="javascript:void(0);" (click)="openSubMenu($event)">
            <i class="fa fa-product-hunt fa-nav" title="{{ 'PRODUCTS' | translate }}"></i>
            <span>
              {{ 'PRODUCTS' | translate }}
            </span>
            <i class="fa arrow"></i>
          </a>
          <ul class="sub-menu">
            <li class="sub-menu-title">{{ 'PRODUCTS' | translate }}</li>
            <li [appAbility]="'index_tour_accountadmin'">
              <a href="#/tours" (click)="openSubMenuLink()">
                <i class="fa fa-binoculars"></i>
                {{ 'TOURS' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_transportation_accountadmin'">
              <a href="#/transportation" (click)="openSubMenuLink()">
                <i class="fa fa-truck"></i>
                {{ 'TRANSPORTATION' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_hotel_accountadmin'">
              <a href="#/hotels" (click)="openSubMenuLink()">
                <i class="fa fa-bed"></i>
                {{ 'HOTELS' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_package_accountadmin'">
              <a href="#/packages" (click)="openSubMenuLink()">
                <i class="fa fa-suitcase"></i>
                {{ 'PACKAGES' | translate }}
              </a>
            </li>
          </ul>
        </li>

        <!-- Websites -->
        <li [appAbility]="['index_website_both']" id="websites">
          <a routerLink="/ng/websites" (click)="openSubMenu($event)">
            <i class="fa fa-chrome fa-nav" title="{{ 'WEBSITES' | translate }}"></i>
            <span>
              {{ 'WEBSITES' | translate }}
            </span>
          </a>
        </li>

        <!-- Contacts -->
        <li
          [appAbility]="[
            'index_client_accountadmin',
            'index_provider_accountadmin',
            'index_teammember_accountadmin'
          ]"
          id="contacts"
        >
          <a href="javascript:void(0);" (click)="openSubMenu($event)">
            <i class="fa fa-users fa-nav" title="{{ 'CONTACTS' | translate }}"></i>
            <span>
              {{ 'CONTACTS' | translate }}
            </span>
            <i class="fa arrow"></i>
          </a>
          <ul class="sub-menu">
            <li class="sub-menu-title">{{ 'CONTACTS' | translate }}</li>
            <li [appAbility]="'index_client_accountadmin'">
              <a href="#/clients" (click)="openSubMenuLink()">
                <i class="fa fa-user"></i>
                {{ 'CLIENTS' | translate }}
              </a>
            </li>
            <!--            <li [appAbility]="'index_client_accountadmin'">-->
            <!--              <a routerLink="/ng/clients" (click)="openSubMenuLink()">-->
            <!--                <i class="fa fa-user"></i>-->
            <!--                {{ 'CLIENTS' | translate }}-->
            <!--              </a>-->
            <!--            </li>-->
            <li [appAbility]="'index_provider_accountadmin'">
              <a href="#/providers" (click)="openSubMenuLink()">
                <i class="fa fa-user"></i>
                {{ 'PROVIDERS' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_teammember_accountadmin'">
              <a href="#/team_members" (click)="openSubMenuLink()">
                <i class="fa fa-users"></i>
                {{ 'TEAM_MEMBERS' | translate }}
              </a>
            </li>
          </ul>
        </li>

        <!-- Sales -->
        <li [appAbility]="['hide']" id="sales">
          <!-- [appAbility]="[
            'index_invoice_accountadmin',
            'index_creditnote_accountadmin',
            'index_receivedpayment_accountadmin'
          ]" -->
          <a href="javascript:void(0);" (click)="openSubMenu($event)">
            <i class="fa fa-money fa-nav" title="{{ 'SALES' | translate }}"></i>
            <span>
              {{ 'SALES' | translate }}
            </span>
            <i class="fa arrow"></i>
          </a>
          <ul class="sub-menu">
            <li class="sub-menu-title">{{ 'SALES' | translate }}</li>
            <li [appAbility]="'index_invoice_accountadmin'">
              <a href="#/invoices" (click)="openSubMenuLink()">
                <i class="fa fa-file-text-o"></i> {{ 'INVOICES' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_creditnote_accountadmin'">
              <a href="#/credit_notes" (click)="openSubMenuLink()">
                <i class="fa fa-file-o"></i> {{ 'CLIENT_CREDIT_NOTES' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_creditnote_accountadmin'">
              <a href="#/debit_notes" (click)="openSubMenuLink()">
                <i class="fa fa-file-o"></i> {{ 'CLIENT_DEBIT_NOTES' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_invoicereport_accountadmin'">
              <a routerLink="/ng/sales_report" (click)="openSubMenuLink()">
                <i class="fa fa-file-text"></i> {{ 'SALES_REPORT' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_cashclosingreport_accountadmin'">
              <a routerLink="/ng/cash_closing_report" (click)="openSubMenuLink()">
                <i class="fa fa-file-text"></i> {{ 'CASH_CLOSING_REPORT' | translate }}
              </a>
            </li>
          </ul>
        </li>

        <!-- Purchases / Bills -->
        <li [appAbility]="['hide']" id="purchases">
          <!-- 'index_bill_accountadmin',
        'index_paymentprovider_accountadmin',
        'index_providercreditnote_accountadmin',
        'index_purchase_report_accountadmin' -->
          <a href="javascript:void(0);" (click)="openSubMenu($event)">
            <i class="fa fa-shopping-cart fa-nav" title="{{ 'PURCHASES' | translate }}"></i>
            <span>
              {{ 'PURCHASES' | translate }}
            </span>
            <i class="fa arrow"></i>
          </a>
          <ul class="sub-menu">
            <li class="sub-menu-title">{{ 'BILLS' | translate }}</li>
            <!-- Cambiar permiso -->
            <li [appAbility]="'index_bill_accountadmin'" class="sub_bills">
              <!-- *ngIf="atvCrEnabled" -->
              <a href="#/confirm_xmls">
                <i class="fa fa-file-code-o"></i> {{ 'CONFIRM_XML' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_bill_accountadmin'" class="sub_bills">
              <a href="#/bills"> <i class="fa fa-file-text-o"></i> {{ 'BILLS' | translate }} </a>
            </li>
            <li [appAbility]="'index_providercreditnote_accountadmin'">
              <a href="#/provider_credit_notes" (click)="openSubMenuLink()">
                <i class="fa fa-file-o"></i> {{ 'PROVIDER_CREDIT_NOTES' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_billreport_accountadmin'">
              <a routerLink="/ng/purchases_report" (click)="openSubMenuLink()">
                <i class="fa fa-file-text"></i> {{ 'PURCHASES_REPORT' | translate }}
              </a>
            </li>
          </ul>
        </li>

        <!-- Reports -->
        <li [appAbility]="['hide']" id="reports">
          <!-- 'index_activitylog_both', 'index_booking_accountadmin' -->
          <a href="javascript:void(0);" (click)="openSubMenu($event)">
            <i class="fa fa-bar-chart fa-nav" title="{{ 'REPORTS' | translate }}"></i>
            <span>
              {{ 'REPORTS' | translate }}
            </span>
            <i class="fa arrow"></i>
          </a>
          <ul class="sub-menu">
            <li class="sub-menu-title">{{ 'REPORTS' | translate }}</li>
            <li [appAbility]="'index_activitylog_both'">
              <a href="#/activity_logs" (click)="openSubMenuLink()">
                <i class="fa fa-file-text"></i>
                {{ 'ACTIVITY_LOGS' | translate }}
              </a>
            </li>
          </ul>
        </li>

        <!-- Accounting -->
        <li [appAbility]="['hide']" id="accounting">
          <!-- index_accountcatalog_accountadmin -->
          <a href="javascript:void(0);" (click)="openSubMenu($event)">
            <i class="fa fa-bar-chart fa-nav" title="{{ 'ACCOUNTING' | translate }}"></i>
            <span>
              {{ 'ACCOUNTING' | translate }}
            </span>
            <i class="fa arrow"></i>
          </a>
          <ul class="sub-menu">
            <li class="sub-menu-title">{{ 'REPORTS' | translate }}</li>
            <li [appAbility]="'index_accountcatalog_accountadmin'">
              <a routerLink="/ng/chart_accounts" (click)="openSubMenuLink()">
                <i class="fa fa-file-text"></i>
                {{ 'CHART_ACCOUNTS' | translate }}
              </a>
            </li>
          </ul>
        </li>

        <li id="settings">
          <a href="javascript:void(0);" (click)="openSubMenu($event)">
            <i class="fa fa-cog fa-nav"></i>
            <span>{{ 'SETTINGS' | translate }}</span>
            <i class="fa arrow"></i>
          </a>
          <ul class="sub-menu">
            <li class="sub-menu-title">{{ 'SETTINGS' | translate }}</li>
            <li>
              <a routerLink="/ng/account_settings" (click)="openSubMenuLink()">
                <i class="fa fa-user"></i> {{ 'ACCOUNT' | translate }}
              </a>
            </li>
            <li>
              <a routerLink="/ng/company_settings" (click)="openSubMenuLink()">
                <i class="fa fa-building"></i>
                {{ 'COMPANY' | translate }}
              </a>
            </li>
          </ul>
        </li>

        <!-- CRM -->
        <li [appAbility]="['index_opportunities_accountadmin']" id="crm" *ngIf="showCrm">
          <a href="javascript:void(0);" (click)="openSubMenu($event)">
            <i class="fa fa-handshake-o" title="{{ 'CRM' | translate }}"></i>
            <span>
              {{ 'CRM' | translate }}
            </span>
            <i class="fa arrow"></i>
          </a>
          <ul class="sub-menu">
            <li class="sub-menu-title">{{ 'CRM' | translate }}</li>
            <li [appAbility]="'index_opportunities_accountadmin'">
              <a routerLink="/ng/opportunities" (click)="openSubMenuLink()">
                <i class="fa fa-bullseye"></i>
                {{ 'OPPORTUNITIES' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_leads_accountadmin'">
              <a routerLink="/ng/leads" (click)="openSubMenuLink()">
                <i class="fa fa-user"></i>
                {{ 'LEADS' | translate }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <!-- SUPER ADMIN -->
    <div *ngIf="currentUser.sd">
      <ul id="nav">
        <li id="dashboard'">
          <a href="#/" (click)="openSubMenu($event)">
            <i class="fa fa-tachometer fa-nav"></i>
            <span>
              {{ 'DASHBOARD' | translate }}
            </span>
          </a>
        </li>
        <li [appAbility]="'index_account_superadmin'" id="accounts">
          <a href="#/accounts" (click)="openSubMenu($event)">
            <i class="fa fa-sitemap fa-nav"></i>
            <span>
              {{ 'ACCOUNTS' | translate }}
            </span>
          </a>
        </li>
        <li [appAbility]="'index_plan_superadmin'" id="plans">
          <a href="#/plans" (click)="openSubMenu($event)">
            <i class="fa fa-credit-card fa-nav"></i>
            <span>
              {{ 'PLANS' | translate }}
            </span>
          </a>
        </li>
        <li id="features">
          <a href="javascript:void(0);" (click)="openSubMenu($event)">
            <i class="fa fa-cog fa-nav" title="{{ 'FEATURES' | translate }}"></i>
            <span>
              {{ 'FEATURES' | translate }}
            </span>
            <i class="fa arrow"></i>
          </a>
          <ul class="sub-menu">
            <li class="sub-menu-title">{{ 'FEATURES' | translate }}</li>
            <li [appAbility]="'index_feature_superadmin'">
              <a href="#/feature_categories" (click)="openSubMenuLink()">
                <i class="fa fa-angle-right"></i>
                {{ 'FEATURE_CATEGORIES' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_feature_superadmin'">
              <a href="#/features" (click)="openSubMenuLink()">
                <i class="fa fa-angle-right"></i>
                {{ 'FEATURES' | translate }}
              </a>
            </li>
            <li [appAbility]="'index_addon_superadmin'">
              <a href="#/addons" (click)="openSubMenuLink()">
                <i class="fa fa-angle-right"></i>
                {{ 'ADDONS' | translate }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>
